import { useState, forwardRef } from 'react';

import Grid from '@material-ui/core/Grid';
import TextField from '@base/Inputs/Text';
import Dialog from '@base/Dialog';
import BuscaEscola from '@base/Inputs/BuscaEscola'
import { ButtonSave } from "@base/Button/ButtonForm"
import ObjetoPostalService from '../../../../services/ObjetoPostalService';

export const IncluirEscolaDialog = forwardRef((props, ref) => {
  const [loading, ] = useState(false);
  const [open, ] = useState(props.aberto ?? false);
  const [novaEscola, setNovaEscola] = useState({});


  const escolaEncontrada = (escola) => {
		setNovaEscola(escola);
	};

  const submit = () => {

    ObjetoPostalService.incluirEscola(props.processo.id,props.numeroObjetoPostal,{
      "escola" : novaEscola.codigoInep,
      "processo" : props.processo.id,
      "numeroObjetoPostal" : props.numeroObjetoPostal
    }).then(resultado => {
      props.aoSalvar(resultado.data);
    });


  }

  return (
    <Dialog
      maxWidth={'md'}
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={open}
      title='Incluir Escola'
      actions={<ButtonSave loading={loading} name={"Salvar"} onClick={submit} />}
    >
      <Grid container>
        <Grid item sm={12}>
          <TextField
            label="Numero do Objeto Postal"
            value={props.numeroObjetoPostal}
            readonly={true}
          />
        </Grid>
      </Grid>

      {!novaEscola.nome &&
					<Grid container>
						<Grid item sm={12}>
							<BuscaEscola
								size={4}
								autoFocus
								ocultarsubtitulo
								label={"Nova Escola"}
								processo={props.processo}
								aoencontrar={escolaEncontrada}
								aonaoencontrar={() => {}}
							/>
						</Grid>
					</Grid>}

					{novaEscola.nome &&
					<Grid container >
						<Grid item sm={12}>
								<TextField
										label="Nova Escola"
										value={novaEscola.nome}
										readonly={true}
									/>
						</Grid>
					</Grid>}

    </Dialog>
  );
})

export default IncluirEscolaDialog;
